import { render } from "./mvt-cardproperty-pagination.vue?vue&type=template&id=493cfe36"
import script from "./mvt-cardproperty-pagination.vue?vue&type=script&lang=js"
export * from "./mvt-cardproperty-pagination.vue?vue&type=script&lang=js"

import "./mvt-cardproperty-pagination.vue?vue&type=style&index=0&id=493cfe36&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__